export const NoVerifyReasonType = {
  Intentional: 'Intentional',
  Unintentional: 'Unintentional',
};
